package com.patronat.top.features.venues.domain.usecase.command

data class GetVenueByIdCommand(
    val venueId: String
)
